// extracted by mini-css-extract-plugin
export default {"cvError":"p2-z"};